import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { adminGate } from '@/lib/adminGate';

export function RequireAdmin({ children }: { children: ReactNode }) {
  const { isReady, token, role } = useAuth();
  const gate = adminGate({ isReady, token, role });
  if (gate === 'loading') return null;
  if (gate === 'signin') return <Navigate to="/sign-in" replace />;
  if (gate === 'notauthorised') return <Navigate to="/not-authorised" replace />;
  return <>{children}</>;
}
